import { jsx as _jsx } from "react/jsx-runtime";
/**
 * FileText icon component for the File Upload action type in selectors and lists.
 */
import { FileText } from "lucide-react";
/**
 * Icon component for the file upload step type.
 * @param root0 - The component props
 * @param root0.className - CSS class name for styling
 * @returns The FileText icon from lucide-react
 */
export function Icon({ className }) {
    return _jsx(FileText, { className: className });
}
//# sourceMappingURL=Icon.js.map